import { render, staticRenderFns } from "./receive-record.vue?vue&type=template&id=69853d10&scoped=true"
import script from "./receive-record.vue?vue&type=script&lang=js"
export * from "./receive-record.vue?vue&type=script&lang=js"
import style0 from "./receive-record.vue?vue&type=style&index=0&id=69853d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69853d10",
  null
  
)

export default component.exports